import React from 'react';
import UIDataTableHeadCell from './DataTableHeadCell';

export const UIDataTableHeadCellOpenRecord = () => {
  return <UIDataTableHeadCell width="xs" padding="none" />;
};

export default UIDataTableHeadCellOpenRecord;
